<h3 mat-dialog-title>{{'auswahl' | translate}}...</h3>
<mat-dialog-content class="mat-typography">
    <mat-selection-list #list style="overflow: hidden;">
      <mat-list-option (click)="onAreaListControlChanged(list)" *ngFor="let opt of data['ref'].options" [selected]="opt.selected" [value]="opt">
        {{getTitle(opt.item)}}
      </mat-list-option>
    </mat-selection-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="first-btn" [mat-dialog-close]="true">Ok</button>
</mat-dialog-actions>